import { render, staticRenderFns } from "./albumLookShops.vue?vue&type=template&id=0dfae4da&scoped=true"
import script from "./albumLookShops.vue?vue&type=script&lang=ts"
export * from "./albumLookShops.vue?vue&type=script&lang=ts"
import style0 from "./albumLookShops.vue?vue&type=style&index=0&id=0dfae4da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dfae4da",
  null
  
)

export default component.exports